import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmMakeForm from '../../../components/forms/FirearmMakeForm';
import { useCreateFirearmMake } from '../../../hooks/useFirearmMakeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmMakeDTO } from '../../../services/apiClient';

const FirearmMakeCreate: React.FC = () => {
  const createFirearmMake = useCreateFirearmMake();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Makes', href: '/admin/firearmmakes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FirearmMakeDTO) => {
    try {
      await createFirearmMake.mutateAsync(data);
      navigate('/admin/firearmmakes');
    } catch (error) {
      console.error('Error creating FirearmMake:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmmakes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmMake.Edit'
    >
        <FirearmMakeForm
          initialValues={{} as FirearmMakeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/firearmmakes')}
        />
    </AdminLayout>
  );
};

export default FirearmMakeCreate;